<h1 mat-dialog-title>
    {{title | translate}}
</h1>
<div mat-dialog-content>
    <app-change-password (output)="closeAfterSubmit($event)"
                         (exit)="closeAfterCancel($event)">
    </app-change-password>
</div>